import { createModalExecutor } from '@organisms/actions/createModalExecutor';
import { IViewAttachSignProps } from './IViewAttachSignProps';
import { ViewAttachSignModal } from './ViewAttachSignModal';

export const ViewSignExecutor = createModalExecutor<IViewAttachSignProps>({
    modal: ViewAttachSignModal,
    defaultModalSize: 'xl',
    emptyElement: <div />,
    mapProps: ({ objId, parentId, action, rowData, cancelButtonText, modalSize, completeHandler }) => ({
        docId: parentId ?? '',
        attachId: Number(objId),
        rowData: rowData,
        options: action.options,
        cancelButtonText,
        modalSize,
        completeHandler,
    }),
});
